import { Box, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import Downloader from "../../components/pdf_downloader/Downloader";

export default function Recruitments(){
    const {fontSize} = useTheme();
    return(
        <Box sx={{}}>
            <Typography variant="h1" sx={{fontSize:`${fontSize+0.5}rem`, margin:"5px 0"}}>Recruitments</Typography>
            <hr/>
            <Box sx={{borderLeft:"5px solid #0b4285", padding:"2px 0 2px 10px", marginTop:"20px", backgroundColor:"whitesmoke"}}>
                <Downloader url={"pdf/recruitments/Advertisement Program_Manager -W,IT & DA.pdf"} name={"Advertisement for the post of Junior Consultant & Programme Manager - Web, Information Technology and Data Analyst"}/> 
                <Downloader url={"pdf/recruitments/Result_JC_PM-WB-IT-DA_27July2023.pdf"} name={"Result for the post of Junior Consultant & Programme Manager - Web, Information Technology and Data Analyst"}/> 
                <Downloader url={"pdf/recruitments/Notification_Personal_Interview_PM_Web.pdf"} name={"Schedule date of Personal Interview for the post of Programme Manager - Web, Information Technology and Data Analyst"}/> 
                <Downloader url={"pdf/recruitments/Personal_Interview_JuniorConsultant_14-07-2023.pdf"} name={"Schedule date of Personal Interview for the post of Junior Consultant (Garo Hills Region) "}/> 
                <Downloader url={"pdf/recruitments/Technical_Test_PM-WIT&DA_14-07-2023.pdf"} name={"Schedule date of Technical Test for the post of Programme Manager - Web, Information Technology and Data Analyst"}/> 
            </Box>
        </Box>
    )
}